import { defineStore } from "pinia";

import type { CreateInviteDto } from "~/common/interfaces/dto/invite/create-invite.dto";
import type { SuccessDto } from "~/common/interfaces/dto/success.dto";
import type { Invite } from "~/common/interfaces/entities/invite.interface";

export const useInviteStore = defineStore("invite", () => {
	const createOne = (dto: CreateInviteDto): Promise<SuccessDto> => {
		return useNuxtApp().$apiFetch<SuccessDto>("/invite", {
			method: "POST",
			body: dto
		});
	};
	const getById = (id: number): Promise<Invite> => {
		return useNuxtApp().$apiFetch<Invite>(`/invite/${id}`);
	};
	const getAll = (): Promise<Invite[]> => {
		return useNuxtApp().$apiFetch<Invite[]>("/invite");
	};

	return { createOne, getById, getAll };
});
